export default __webpack_public_path__ + "static/bars-be30a79856f2e2d29e0489ce15b6e8fc.png";